import { render } from "./BuyAVehicle.vue?vue&type=template&id=7756c5ca&lang=true"
import script from "./BuyAVehicle.vue?vue&type=script&lang=js"
export * from "./BuyAVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/BuyAVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7756c5ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7756c5ca', __exports__)) {
    api.reload('7756c5ca', __exports__)
  }
  
  module.hot.accept("./BuyAVehicle.vue?vue&type=template&id=7756c5ca&lang=true", () => {
    api.rerender('7756c5ca', render)
  })

}


export default __exports__